import React from 'react';
import { withRouter } from 'react-router-dom';
import { Level } from 'rbx';
import { PageHeader } from '../../../components/elements';
import Can from '../../../utils/Can';
import { ACLSConsumer } from '../../../utils/aclsContext';

const Header = ({
  activeTab,
  loading,
  handleSubmit,
  location,
  companyName,
  next,
  prev,
  history,
}) => (
  <PageHeader
    title={
      location.pathname === '/add-company'
        ? 'Add a Company'
        : `Edit - ${companyName}`
    }
    // otherText={location.pathname === '/add-company' ? '' : `${companyName} `}
  >
    <Level.Item align="right">
      <Level.Item>
        <Level.Item>
          <a onClick={() => history.goBack()} className="button is-light">
            <span>Cancel</span>
          </a>
        </Level.Item>
      </Level.Item>
      {activeTab !== 0 && (
        <Level.Item>
          <button onClick={prev} className="button is-primary">
            <span>Prev Tab</span>
          </button>
        </Level.Item>
      )}
      <ACLSConsumer>
        {({ apiActions, pageActions }) => (
          <Can
            action={`${
              location.pathname === '/update-company'
                ? 'update_company'
                : 'create_company'
            }`}
            apiActions={apiActions}
            pageActions={pageActions}
            yes={() => (
              <Level.Item>
                <button
                  className={`button is-primary ${loading && 'is-loading'}`}
                  onClick={handleSubmit}
                >
                  <span>Submit</span>
                </button>
              </Level.Item>
            )}
          />
        )}
      </ACLSConsumer>

      {activeTab !== 2 && (
        <Level.Item>
          <button onClick={next} className="button is-primary">
            <span>Next Tab</span>
          </button>
        </Level.Item>
      )}
    </Level.Item>
  </PageHeader>
);

export default withRouter(Header);
